import React from 'react';
import { connect } from 'react-redux'


class SchulteLetters extends React.Component {
  componentWillUnmount() {
    clearInterval(this.state.timer);
    if(this.state.endTick)
    {
      clearTimeout(this.state.endTick)
    }
  }
  componentDidMount() {
    if(this.props.started) {
      let timer = setInterval(
        () => {
          this.props.increment();
        },
        this.props.interval
      );
      this.setState({timer})
    } else {
      this.setState({timer: 'waiting'})
    }
  }
  componentDidUpdate() {
    if(this.props.started && this.state.timer === 'waiting') {
      let timer = setInterval(
        () => {
          this.props.increment();
        },
        this.props.interval
      );
      this.setState({timer})
    }
  }
  render() {   
    
    if(this.props.incrementCounter === 1 || this.props.incrementCounter === -1)
    {
      clearInterval(this.state.timer);
      setTimeout(
        () => {
          this.props.increment();
          this.props.timerFinished();
          clearInterval(this.state.timer);
          this.setState({timer: 'done'})
        },
        this.props.interval
      )
    }
    return (
      <></>
    )
  }
}
export default connect()(SchulteLetters)
